import { api } from '@/core/helpers/axiosHelper';
import { authLandingPageInterceptors } from '@/core/interceptors/auth.interceptor';
import { CancelToken } from 'axios';
import { Company } from '../company/company.interface';
import { Squad } from '../squad/squad.interface';
import { Board } from './board.interface';

export default {
   async get({
      page,
      search_value,
      include,
      sort,
      fields,
      cancelToken,
      per_page,
   }: {
      page?: number;
      search_value?: string;
      include: string;
      sort?: string;
      fields?: string;
      cancelToken?: CancelToken;
      per_page: number;
   }) {
      return await api
         .get('/board', {
            params: {
               include,
               per_page,
               page: page,
               'filter[search]': search_value,
               sort,
               'fields[boards]': fields,
            },
            cancelToken: cancelToken,
         })
         .then((response) => response?.data);
   },
   async getBoardById(board_id: number, append: string, space: boolean) {
      return await api
         .get(`/board/${board_id}`, {
            params: {
               'fields[boards]':
                  'is_shift_candidate_application_allowed,hide_squads_without_shifts,description,show_sum_slot_hours_planned,minimum_seconds_between_shift,name,has_squad_filter_permissions,is_candidate_available_by_default',
               include:
                  'timetables,squads,squadsCount,board_tenants.tenant,tag_types.tags,pools.tenant,companies,property_types.properties,squad_filtersCount',
               append,
            },
         })
         .then((response) => {
            return response?.data;
         })
         .catch((error) => {
            if (!space) authLandingPageInterceptors(error);
            return error;
         });
   },
   async fetchScopes(board_id: number) {
      return await api
         .get(`/board/${board_id}`, {
            params: {
               'fields[boards]': 'boards.id',
               append: 'scopes',
            },
         })
         .then((response) => {
            return response?.data;
         });
   },
   async put(board_id: number, include: string, body: Board) {
      return await api
         .put(`/board/${board_id}`, body, {
            params: { include },
         })
         .then((response) => response.data);
   },
   async patch(board_id: number, body: Array<{ op: string; path: string; value: boolean }>) {
      return await api
         .patch(`/board/${board_id}`, body, { params: { append: 'minimum_seconds_between_shift' } })
         .then((response) => response.data);
   },
   async getNxtPaySettings(board_id: number) {
      return await api.get(`/board/${board_id}/nxt-pay-settings`).then((response) => response?.data);
   },
   async postNxtPaySettings(board_id: number, body: { type: string; property_type_id: number; companies: Array<Company> }) {
      return await api
         .post(`/board/${board_id}/nxt-pay-settings`, body, {
            params: { include: 'property_types.properties.departments,timetables.pay_shifts' },
         })
         .then((response) => response.data);
   },
};
